<script lang="ts">
    import { onMount } from "svelte";
    import { HighlightStore } from "$/stores/HighlightStore";
    import { getRootDocument } from "$/utils/Utils";
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let isMouseDown = false;
    let isScrolling = false;
    let mouseDownPosition = { x: 0, y: 0 };

    function checkHighlightAtPosition(x: number, y: number) {
        const yOffset = window.scrollY;
        const mouseTopPos = y + yOffset;
        const mouseLeftPos = x + window.scrollX;

        for (const [id, highlight] of $HighlightStore) {
            const { top, left, width, height } = highlight;
            
            const mouseTopInRange = mouseTopPos >= top && mouseTopPos <= (top + height);
            const mouseLeftInRange = mouseLeftPos >= left && mouseLeftPos <= (left + width);

            if (mouseTopInRange && mouseLeftInRange) {
                dispatch('highlight-clicked', { snippetId: id });
                return true;
            }
        }
        return false;
    }

    function getCurrentRange(): Range | undefined {
        const selection = document.getSelection();
        if (!selection?.rangeCount) return;
        const range = selection.getRangeAt(0);
        //ignore contenteditable elements
        if (
            (range?.commonAncestorContainer?.nodeType == 1
                ? (range?.commonAncestorContainer as HTMLElement)
                : range?.commonAncestorContainer?.parentElement
            )?.closest('[contenteditable=""], [contenteditable=true]')
        )
            return;
        return range;
    }

    function handleMouseDown(e) {
        if (e.target.closest(".js-collabwriting-app")) return;
        isMouseDown = true;
        isScrolling = false;
        mouseDownPosition = { x: e.clientX, y: e.clientY };
    }

    function handleMouseMove(e) {
        if (isMouseDown) {
            const distance = Math.sqrt(
                Math.pow(e.clientX - mouseDownPosition.x, 2) + 
                Math.pow(e.clientY - mouseDownPosition.y, 2)
            );
            if (distance > 5) { 
                isScrolling = true;
            }
        }
    }

    function handleMouseUp(e) {
        if (e.target.closest(".js-collabwriting-app")) return;
        if (e.target.closest("img") || e.target.closest("svg")) return;
        
        if (isScrolling) {
            isMouseDown = false;
            return;
        }

        const clickedOnHighlight = checkHighlightAtPosition(e.clientX, e.clientY);
        
        if (!clickedOnHighlight) {
            const selection = window.getSelection();
            if (selection && selection.toString().trim()) {
                // Handle new text selection 
        
            }
        }
        
        isMouseDown = false;
    }

    onMount(() => {
        getRootDocument("web").addEventListener("mousedown", handleMouseDown);
        getRootDocument("web").addEventListener("mousemove", handleMouseMove);
        getRootDocument("web").addEventListener("mouseup", handleMouseUp);
        
        return () => {
            getRootDocument("web").removeEventListener("mousedown", handleMouseDown);
            getRootDocument("web").removeEventListener("mousemove", handleMouseMove);
            getRootDocument("web").removeEventListener("mouseup", handleMouseUp);
        };
    });
</script>

<!-- for now only on click will locate highlight so stuff to add here is useless, but in future will add html for toolbar-->
